'use client'

import { Icon } from '@/components'
import { useAccountStore } from '@/store/accounts'
import { Button, styled } from '@mui/material'
import { useTranslations } from 'next-intl'
import Link from '@/features/ref/components/Link'
const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  padding: '10px 20px',
  borderRadius: '999px',
  fontSize: '1rem',
  fontWeight: 700,
  color: 'white',
  lineHeight: 1.5,
  marginTop: '3px',
}))

export const UserLogin = () => {
  const { data } = useAccountStore()
  const t = useTranslations('UserProfile')
  const isExist = Object.keys(data).length > 0

  return (
    <>
      <StyledButton
        sx={{ display: { xs: 'none', md: 'inline-flex' } }}
        LinkComponent={Link}
        href={isExist ? '/accounts' : '/login'}
        startIcon={<Icon.User sx={{ width: 16, height: 16 }} />}
      >
        {isExist ? data?.firstname : t('signin')}
      </StyledButton>
      {/* <IconButton
        sx={(theme) => ({
          background: theme.palette.primary.light,
          padding: '10px',
          '&:hover': { background: '#222' },
          position: 'relative',
          display: { xs: 'inline-flex', md: 'none' },
        })}
      >
        <Icon.User sx={{ width: 16, height: 16, color: 'primary.main' }} />
      </IconButton> */}
    </>
  )
}
